import React from 'react'
import { Button, Progress, Icon, Popover } from 'antd'
import prettysize from '../../../../utils'
import moment from "moment"
import css                     from "classnames"

import '../styles.scss'

export default ({file, on_remove, on_error_fix }) => {
  let {name, size, type, $percent, $status, $speed, $error, $eta, $time_left,
    bucket_name,
    started,
    uploaded_count,
    uploaded_size,
    status,
    end_time,
    start_time,

    $id,
    $failed_count,
    $succeeded_count,
    $uploaded,
    $directory,
    $started,
    $ended,
    $completed,
    $failed,
    $cancelled,
    $duration
  } = file

  if($status !== 'exception' && $status !== 'active'){
    $status = 'normal'
  }

  //debugger
  return (
  <div className='file-item columnWrap'>
    { type === 'directory' ? <Icon type="folder" /> : <Icon type="file-text"/>}

    <div>
      <span>{decodeURIComponent(name + (bucket_name ? ' → ' + bucket_name : '') )} </span>
      {
        bucket_name ?
        (
          <div>
            <Progress className={css({'hidden': type === 'directory' && $completed})} percent={parseFloat($percent) ? parseFloat($percent) : 0} strokeWidth={5} status={$status} showInfo={false}/>
            <span>{$eta > 0 ? ($speed.toUpperCase() + '/s - ' + prettysize(size) + ' - ' + moment($time_left).toNow(true) + ' left') : ''}</span>
          </div>
        ) : null
      }
      { (type === 'directory' && $started) ?
        <div>
          {
            $completed ? (`${$succeeded_count} files uploaded in ${$duration} s`):
                (`Uploaded ${$succeeded_count} files with total size of ${prettysize($uploaded)}`)
          }
          </div>
        : null
      }
    </div>

    {($status === 'exception' && !$cancelled) ?
      (
        <Popover content={
          (
            <div>
              <p>Click apply to fix cors settings
                <br/>on the destination bucket</p>
              <Button onClick={() => on_error_fix(file)}>Apply</Button>
            </div>
          )
        } title={$error}>
          <Button shape="circle" icon="exclamation-circle-o" size={'small'}/>
        </Popover>
      ) : null}

    <Button shape="circle" icon="close" size={'small'} onClick={() => on_remove(file)}/>
  </div>
)}
